import { Button, TabBar, Text } from '@viapeople/components'
import { useState } from 'react'
import { Outlet, useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom'
import type { Cycle, Organization } from '../types'

const tabs = [
	{ id: 'list', label: 'Cycle Emails' },
	{ id: 'email-history', label: 'Email History' },
	{ id: 'email-footer', label: 'Email Footer' },
	{ id: 'global-exclusions', label: 'Global Exclusions' },
]

export function CycleEmailsTab() {
	const { organizationId, cycleId } = useParams<{ organizationId: string; cycleId: string }>()
	const navigate = useNavigate()
	const location = useLocation()
	const { organization, cycle } = useOutletContext<{ organization: Organization; cycle: Cycle }>()
	const [configureEmailModal, setConfigureEmailModal] = useState(false)
	const pathArray = location.pathname.split('/')
	//TODO: Improve this
	const currentTab = pathArray?.[6] ?? 'list'

	const handleTabChange = (tabId: string) => {
		navigate(`/organizations/${organizationId}/cycles/${cycleId}/emails/${tabId}`)
	}

	return (
		<>
			<div className='flex items-center justify-between mt-6 mb-3 h-13'>
				<Text variant='medium' weight='semibold'>
					Emails Overview
				</Text>
				{currentTab === 'list' && (
					<div className='flex items-center justify-between gap-2'>
						<Button
							variant='secondary'
							onClick={() => {
								navigate(`/organizations/${organizationId}/cycles/${cycleId}/emails/send-manual-email`)
							}}>
							Send Manual Email
						</Button>

						<Button variant='primary' onClick={() => setConfigureEmailModal(true)}>
							Configure New +
						</Button>
					</div>
				)}
			</div>
			<div className='bg-white rounded-lg shadow-table'>
				<div className='flex justify-between items-center'>
					<TabBar tabs={tabs} activeTab={currentTab} onChange={handleTabChange} />
				</div>
				<Outlet context={{ organization, cycle, configureEmailModal, setConfigureEmailModal }} />
			</div>
		</>
	)
}
